// API client helpers extracted from App.js
// Keep legacy-friendly syntax.

var API_URL = process.env.REACT_APP_API_URL || '';

export function getApiBase() {
    return (API_URL || '').replace(/\/$/, '');
}

export function getApiUrl(path) {
      return (getApiBase() || '') + path;
}

export function buildApiClient(apiBase) {
    function api(path) {
        return (apiBase || '') + path;
    }

    function getAuthHeaders() {
        var headers = {};
        try {
            var token = localStorage.getItem('bb_session');
            if (token) {
                headers['Authorization'] = 'Bearer ' + token;
            }
            var uid = localStorage.getItem('bb_user_id');
            if (uid) {
                headers['X-User-Id'] = String(uid);
            }
        } catch (e) {}
        return headers;
    }

    function withDefaults(options) {
        var opts = options || {};
        if (!opts.credentials) opts.credentials = 'include';
        opts.headers = Object.assign({}, getAuthHeaders(), opts.headers || {});
        return opts;
    }

    function get(path, options) {
        return fetch(api(path), withDefaults(options));
    }

    function postJson(path, payload, options) {
        var opts = withDefaults(options);
        opts.method = opts.method || 'POST';
        opts.headers = Object.assign({ 'Content-Type': 'application/json' }, opts.headers || {});
        opts.body = JSON.stringify(payload || {});
        return fetch(api(path), opts);
    }

    return {
        apiBase: apiBase,
        api: api,
        getAuthHeaders: getAuthHeaders,
        get: get,
        postJson: postJson
    };
}
